import React, { Component } from 'react'
import { Table, Tooltip, Modal, message, Collapse, Form, Select, DatePicker, Button, Radio } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all } from '../../services/restApi'
import { getTotal } from '../../utils'
import IncomeNew from './incomeNew'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;
const ButtonGroup = Button.Group;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class income extends Component {

	constructor (props) {
        super(props);

        this.state = {
        	query: {},
            hotels: [],
            incomes: [],
            showModalNewIncome: false,
            newIncomeProps: {incomeType: this.props.params.incomeType},
            skip: 0,
            limit: 1000
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)  {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        } else {
            if (this.props.location.pathname === '/incomes/incomes_report/cash_funds/' + this.props.params.date)
                window.history.back()
        }

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Consulta los hoteles
        all('Hotel', {limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })
    }


    /**
    * Se llama antes del render()
    */
    componentWillMount () {
        this.props.dispatch({type:'income/filterSuccess', 
            payload: { incomes: [] }
        });

        this.firstLoad();
    }


    /**
    * Agrupamos: Cada tipo de gastos contiene sus gastos
    */
    groupByIncomes (array, count) {
        let query = {type: this.props.params.incomeType};

        _.map(array, (item, key) => {
            setTimeout(() => {
                query.expense = {__type: 'Pointer', className: 'ExpenseType', objectId: item.objectId};

                if (this.props.params.date) {
                    query.requestedAt ={
                        /*$gte: {__type: 'Date', iso: new Date(moment(this.props.form.getFieldValue('custom_date')).startOf('month').format()).toISOString()},
                        $lte: {__type: 'Date', iso: new Date(moment(this.props.form.getFieldValue('custom_date')).endOf('month').format()).toISOString()},*/
                        $gte: {__type: 'Date', iso: new Date(moment(this.props.params.date).startOf('month').format()).toISOString()},
                        $lte: {__type: 'Date', iso: new Date(moment(this.props.params.date).endOf('month').format()).toISOString()},
                    }

                } else {
                    query.requestedAt = {
                        $gte: {__type: 'Date', iso: new Date(moment().startOf('month').format()).toISOString()},
                        $lte: {__type: 'Date', iso: new Date(moment().endOf('month').format()).toISOString()},
                    };
                }

                all('Income', {
                    where: query,
                    include: 'hotel,expense,createdBy', 
                    limit: 1000, 
                    order: '-requestedAt'
                }).then(income => {

                    if (income.results.length > 0) {
                        item.isParent = true;
                        item.expense = income.results[0].expense;
                        item.children = income.results;
                        item.amount_income_total = getTotal(item.children, 'amount_income');
                        item.amount_expense_total = getTotal(item.children, 'amount_expense');

                        this.state.incomes.push(item);
                    }

                    if (key === array.length - 1) {

                        setTimeout(() => {
                            this.props.dispatch({type: 'app/hideLoadingTable'})
                            this.props.dispatch({type:'income/querySuccess', 
                                payload: { incomes: this.state.incomes }
                            });
                        }, 0);
                    }
                }); 
            }, 100 * key)
        });
    }


    /**
    * Primera carga
    */
    firstLoad () {
        if (this.props.params.date) {

            let query = {};
            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

            this.props.dispatch({type: 'app/showLoadingTable'})

            all('ExpenseType', {
                where: query,
                include: 'hotel', 
                skip: 0, 
                limit: this.state.limit, 
                count: 1, 
                order: 'name'
            }).then(resp => {

                this.setState({ skip: this.state.limit, total_items: resp.count });

                if (resp.results.length > 0)
                    this.groupByIncomes(resp.results, resp.count);
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        }
    }


	/**
	* Carga otro bloque de registros
	*/
    loadMore () {
    	if (this.state.skip < this.state.total_items) {

            this.props.dispatch({type: 'app/showLoadingTable'})
            this.setState({ skip: this.state.skip + this.state.limit });

            all('ExpenseType', {
                where: this.state.query,
                include: 'hotel', 
                skip: this.state.skip, 
                limit: this.props.income.limit, 
                count: 1, 
                order: 'name'
            }).then(resp => {

                if (resp.results.length > 0)
                    this.groupByIncomes(resp.results, resp.count);
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error al consultar otros registros. Intente más tarde')    
            });
    	}
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


  	/**
    * Búsqueda
    */
    search () {
        this.props.dispatch({type: 'app/showLoadingTable'})

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query = this.state.query;

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            }

        	if (values.hotel && values.hotel.key) {
        		query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
        	} else {
                query = _.omit(query, ['hotel']);
            }

            all('ExpenseType', {
                where: query,
                include: 'hotel', 
                skip: 0, 
                limit: this.state.limit, 
                count: 1, 
                order: 'name'
            }).then(resp => {
                
                this.setState({incomes: [], skip: this.state.limit, total_items: resp.count});
                this.props.dispatch({type:'income/filterSuccess', 
                    payload: { incomes: [] }
                });

                if (resp.results.length > 0)
                    this.groupByIncomes(resp.results, resp.count);
                else
                    this.props.dispatch({type: 'app/hideLoadingTable'})

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        })
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        let dispatch = this.props.dispatch

        confirm({
            title: '¿Estás seguro que deseas eliminar el registro?',
            onOk () {
                dispatch({type: 'income/removeItem', payload: item});
            }
        })
    }


    /**
    * Establece el registro para editar
    */
    setUpdate (item) {
        this.setState({ newIncomeProps: {incomeId: item.objectId} });
        this.showModalNewIncome();
    }


    /**
    * Muestra / Oculta el modal para nuevo ingreso
    */
    showModalNewIncome () { this.setState({ showModalNewIncome: true }); }
    hideModalNewIncome () { 
        this.props.form.resetFields();
        this.setState({ showModalNewIncome: false, incomes: [] }); 
        this.props.dispatch({type:'income/filterSuccess', 
            payload: {
                incomes: [], 
                skip: this.state.limit, 
                total_items: 0
            }
        });
        this.firstLoad(); 
    }


  	/**
    * Render del componente
    */
    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
                        <Link to={`/incomes/cash_funds/${this.props.params.incomeType}`}><i className="fa fa-arrow-circle-left"></i></Link>
                        Reporte conglomerado
                    </h1>
	            </section>

	            <section className="content">

	            	{/*<Collapse defaultActiveKey={['1']} className="marginBottom20">
					    <Panel header="Filtros" key="1">
					      	<Form onSubmit={this.search.bind(this)}>
                                <div className="row">
                                    {!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-6">
                                        <FormItem label="Periodo" hasFeedback>
                                            {this.props.form.getFieldDecorator('date', {initialValue: 'today'})(
                                                <RadioGroup>
                                                    <RadioButton value="today">Hoy</RadioButton>
                                                    <RadioButton value="week">Esta semana</RadioButton>
                                                    <RadioButton value="month">Este mes</RadioButton>
                                                    <RadioButton value="year">Este año</RadioButton>
                                                    <RadioButton value="custom">Personalizado</RadioButton>
                                                </RadioGroup>
                                            )}
                                        </FormItem>

                                        {this.props.form.getFieldValue('date') === 'custom' 
                                            ? <FormItem>
                                                {this.props.form.getFieldDecorator('custom_date')(
                                                    <RangePicker 
                                                        format="DD-MM-YYYY"
                                                        onOk={resp => {
                                                            console.log(resp);
                                                        }} />
                                                )}
                                            </FormItem>
                                            : ''
                                        }
                                    </div>
                                </div>

	                            <div className="row text-center paddingBottom30">
	                                <Button type='primary' onClick={this.search.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
	                                    Filtrar...
	                                </Button>
	                            </div>
		                    </Form>
					    </Panel>
					</Collapse>*/}

                    {/*<Collapse defaultActiveKey={['1']} className="marginBottom20">
                        <Panel header="Filtros" key="1">
                            <Form onSubmit={this.search.bind(this)}>
                                <div className="row">
                                    {!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-3">
                                        <FormItem label="Mes" hasFeedback>
                                            {this.props.form.getFieldDecorator('custom_date', {
                                                initialValue: moment(new Date, 'YYYY-MM')
                                            })(
                                                <MonthPicker placeholder="Seleccione el mes" />
                                            )}
                                        </FormItem>
                                    </div>
                                </div>

                                <div className="row text-center paddingBottom30">
                                    <Button type='primary' onClick={this.search.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                        Buscar...
                                    </Button>
                                </div>
                            </Form>
                        </Panel>
                    </Collapse>*/}

	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.income.incomes} 
		                                    	rowKey="objectId" 
		                                    	size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>

		                                    	<Column title="Fecha" key="requestedAt" render={(item) => (
		                                        	<span>{!item.isParent ? moment(item.requestedAt.iso).format('l') : ''}</span>
		                                        )} />
                                                {!this.state.currentHotel
    		                                      ? <Column title="Hotel" key="hotel" render={(item) => (
    		                                        	<span>{item.hotel ? item.hotel.name : '-'}</span>
    		                                        )} />
                                                    : ''
                                                }
                                                {/*this.props.app.user && this.props.app.user.type !== 'recepcionista'
                                                  ? <Column title="Creado por" key="createdBy" render={(item) => (
                                                        <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                */}
		                                        <Column title="Tipo de gasto" key="expense" render={(item) => (
                                                    <span>
    		                                        	<span>{item.expense ? item.expense.name : '-'}</span>
                                                        {item.isParent 
                                                            ? <span style={{color: '#108ee9'}}> ({item.children ? item.children.length : 0})</span> 
                                                            : ''
                                                        }
                                                    </span>
		                                        )}/>
		                                        <Column title="Descripción" render={(item) => (
                                                    <span>{item.items ? item.items : ''}</span>
                                                )}/>
		                                        <Column title="Ingreso" key="amount_income" render={(item) => (
                                                    <span>
                                                        {item.isParent
                                                            ? <Currency quantity={item.amount_income_total} currency="USD" />
                                                            : <span>
                                                                {item.amount_income
                                                                    ? <Currency quantity={item.amount_income} currency="USD" />
                                                                    : '-'
                                                                }
                                                            </span>
                                                        }
                                                    </span>
                                                )}/>
                                                <Column title="Egreso" key="amount_expense" render={(item) => (
                                                    <span>
                                                        {item.isParent
                                                            ? <Currency quantity={item.amount_expense_total} currency="USD" />
                                                            : <span>
                                                                {item.amount_expense
                                                                    ? <Currency quantity={item.amount_expense} currency="USD" />
                                                                    : '-'
                                                                }
                                                            </span>
                                                        }
                                                    </span>
                                                )}/>
		                                        {/*<Column title="Acciones" key="action" width={90}
                                                    render={(item) => (
                                                        <span className="actions">
                                                            {!item.isParent
                                                                ? <ButtonGroup>
                                                                    <Tooltip placement="bottom" title="Editar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                                        </Button>
                                                                    </Tooltip>

                                                                    <Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                </ButtonGroup>
                                                                : ''
                                                            }
                                                        </span>
                                                    )}
                                                />*/}
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>

                <Modal
                    width={700}
                    visible={this.state.showModalNewIncome}
                    title="Ingreso / Gasto"
                    onCancel={this.hideModalNewIncome.bind(this)}
                    footer={[]} 
                >
                    {this.state.showModalNewIncome
                        ? <IncomeNew {...this.state.newIncomeProps} />
                        : ''
                    }
                </Modal>
	        </div>
	    )
	}
}

export default connect(({income, app}) => ({income, app}))(Form.create()(income))


// WEBPACK FOOTER //
// ./src/components/incomes/incomeReport.js